export type VehicleView = 'open' | 'closed'

export interface VehicleViewToggleProps {
  value: VehicleView
  onChange: (value: VehicleView) => void
}

const options: ReadonlyArray<{ value: VehicleView; label: string }> = [
  { value: 'open', label: 'Doors open' },
  { value: 'closed', label: 'Doors closed' },
]

export function VehicleViewToggle({ value, onChange }: VehicleViewToggleProps) {
  return (
    <div className="vehicle-view-toggle" role="group" aria-label="Vehicle view">
      {options.map((option) => {
        const selected = value === option.value

        return (
          <button
            className="vehicle-view-toggle__option"
            key={option.value}
            type="button"
            aria-pressed={selected}
            data-active={selected || undefined}
            onClick={() => {
              if (!selected) onChange(option.value)
            }}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
